import axios from "axios";
export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        applyDiscount({}, query) {
            return axios.post("user/payment/discount", query);
        },
    },
};
